import React from "react";
import { connect } from "react-redux";

import { useNavigate } from "../../utils/components/router";
import { basketActions, messageActions } from "../../actions";
import CONFIG from "../../config";
import BasketBaseItem from '../BasketBaseItem';
import { Stepper } from "../../utils/components";
import { scrollToTop } from "../../utils/functions";
import { warningAboveLimitCart, warningAboveLimitCartCustomer } from "../../utils/enums/CONSTANTS";

class BasketMetalsItem extends BasketBaseItem {
  constructor(props) {
    super(props);
    this.handleWeiterleitung = this.handleWeiterleitung.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  checkMaxSumOk(amount) {
    // temporär die Anzahl verändern, ob die Obergrenze gerissen wird
    const testItem = this.props.item.clone();
    testItem.basket = null;
    testItem.changeAmount(amount);
    if (
      this.props.basketStorage.isPriceTooHigh(
        this.props.basketStorage.sum.getPrice() + testItem.brutto.getPrice() - this.props.item.brutto.getPrice()
      )
    ) {      
      return false;
    } else {
      return true;
    }
  }

  displaySumTooHighWarning () {    
    const message = this.props.configStorage.isKundenShop() ? warningAboveLimitCartCustomer : warningAboveLimitCart;
    const warningMessage = message.replace("{value}", this.props.basketStorage.getMaxSumText());
    this.props.dispatch(
      messageActions.showMessage(
        this.props.configStorage.getHtmlId(),
        ".ser-cart", 
        warningMessage
      )
    );
  }

  handleOnChange(value) {
    let increment = this.props.item.amount < value ? true : false;
    if (value > 0 && ( this.checkMaxSumOk(value) || !increment )) {
      this.setState({ itemAmount: value, });
      this.props.dispatch(basketActions.changeAmount(this.props.item, value));
      return true;
    } else {
      this.displaySumTooHighWarning();
      return false;
    }
  }

  handleWeiterleitung() {
    scrollToTop();
    return this.props.navigate(CONFIG.LINK_EMPFEHLUNG + this.props.item.getLinkId());
  }

  getItemPrice() {
    return this.props.item.itemprice.clone().multiply(this.props.item.amount);
  }

  renderItem() {
    let basketStorage = this.props.basketStorage;
    let item = this.props.item;
    return (
      <>
        <td className="text-start" aria-label="Produkt">
          <button
            type="button"
            className="btn btn-link"
            aria-label={item.name + " Details anzeigen"}
            onClick={this.handleWeiterleitung}
          >
            <span className="ser-value itemTitle">{item.name}</span>
          </button>
          <div className="ps-3" aria-label="Produktinfo">
            <span className="f-small text-wrap">{item.produktInfo}</span>
          </div>
        </td>
        <td className="text-end redOnDirty" aria-label="Stückpreis">
          {item.itemprice.toEuro()}
        </td>
        <td className="text-center" aria-label="Stückzahl">
          <div className="ser-stepper-section">
            <Stepper
              id={"stk" + item.kennziffer}
              label={"Stückzahl von " + item.name}
              item={item}
              disabled={basketStorage.locked}
              onChange={this.handleOnChange}
            />
          </div>
        </td>
        {this.renderKonditionChange()}
        <td className="text-end column-1 redOnDirty" aria-label="MwSt.">
          {item.positionMwst.toEuro()}
        </td>
        <td className="text-end col-12 redOnDirty" aria-label="Produktpreis brutto inkl. Konditions&shy;änderung">
          {item.positionSum.toEuro()}
        </td>
        <td aria-hidden="true"></td>
      </>
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage, // used in BasketBaseItem
    configStorage: store.configStorage,
    rightStorage: store.rightStorage, // used in BasketBaseItem
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <BasketMetalsItem navigate={contextNavigate} {...props} />;
});
